import React, { memo } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function UrgencySection() {
  return <section className="py-16 md:py-20 px-6 bg-base" data-id="element-609">
      <div className="max-w-copy mx-auto text-center" data-id="element-610">
        <FadeIn data-id="element-611">
          <span className="inline-block font-ui text-xs font-medium tracking-widest uppercase text-accent-soft border border-accent-muted rounded-full px-4 py-1 mb-8" data-id="element-612">
            Time Sensitive
          </span>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-613">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-text-primary mb-12" data-id="element-614">
            Why Now
          </h2>
        </FadeIn>

        <div className="space-y-8 font-body text-lg leading-relaxed text-text-secondary" data-id="element-615">
          <FadeIn delay={0.3} data-id="element-616">
            <p className="text-text-primary font-medium text-xl" data-id="element-617">
              This is a limited memorial edition.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-618">
            <p data-id="element-619">It is not a permanent fixture in our catalog.</p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-620">
            <p data-id="element-621">
              While the conversation about what happened is still alive — this
              is the moment to have the complete document. Historical archives
              carry more weight when accessed close to the moment they document.
            </p>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-622">
            <p data-id="element-623">
              The story is still being written. This book captures it while the
              ink is still fresh.
            </p>
          </FadeIn>

          <FadeIn delay={0.7} data-id="element-624">
            <p className="font-display text-2xl italic text-accent-primary mt-12" data-id="element-625">
              Once this edition closes — it closes.
            </p>
          </FadeIn>

          <FadeIn delay={0.8} data-id="element-626">
            <div className="flex flex-col items-center mt-12" data-id="element-627">
              <Button href="#offer" className="w-full md:w-auto text-sm md:text-base" data-id="element-628">
                Claim Your Copy Before It Closes &rarr;
              </Button>
              <p className="font-ui text-xs text-text-muted mt-3 tracking-wide" data-id="element-629">
                Memorial edition. Limited availability.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}